import { FEATURE_FLAGS } from '../../../constants/feature-flags';
import { initiateLiveChat, makeTrackLiveChat, initiateEnhancedChat } from '../../../helpers/chat/live-chat.helper';
import { useFeature } from '../../features/features.hooks';
import { useTrackEvent } from '../analytics.hooks';

export const useLiveChat = () => {
	const isEnhancedLiveChatEnabled = useFeature<boolean>(FEATURE_FLAGS.ENHANCED_LIVE_CHAT, { isSiteWide: true });
	const trackEvent = useTrackEvent();
	const trackChat = makeTrackLiveChat(trackEvent);
	if (isEnhancedLiveChatEnabled) {
		return () => initiateEnhancedChat(trackChat);
	} else {
		return () => initiateLiveChat(trackChat);
	}
};
